/* The buy bar — the purchase that never leaves the screen on a phone.
   The design has no such bar; it is the client's ask, and it is the standard shape: the price and
   the product on the left, the same buy button on the right, fixed to the bottom of the viewport.
   It appears only once the REAL button has scrolled off the top of the screen — while the band's
   own button is visible the bar would be a second copy of something the visitor is already
   looking at — and it disappears again if they scroll back up.

   One rect test on scroll, no scroll-position math: the bar shows when the main button's bottom
   edge is above the viewport's top ("the visitor has scrolled past it") and hides the moment it
   comes back — which is also true at load, so a page opened with the button in view shows no bar.
   A rect test rather than an IntersectionObserver for the same reason as the quick bar's: an
   observer cannot be observed in every environment this previews in, and this is the comparison
   the observer would make anyway. The bar's own form is a second {% form 'product' %} on the
   page, with its own id, posting the same variant to the same /cart/add — so it buys with exactly
   the main button's authority. */
(() => {
  const bar = document.querySelector('[data-buybar]');
  if (!bar) return;
  const anchor = document.querySelector('.v2-buyband form button[type="submit"], .v2-buyband .v2-button');
  if (!anchor) return;

  const check = () => bar.classList.toggle('v2-buybar--on', anchor.getBoundingClientRect().bottom <= 0);
  addEventListener('scroll', check, { passive: true });
  addEventListener('resize', check, { passive: true });
  check();
})();
